export const panenkaCaseStudyData = {
  title: 'Case Study: Panenka AI - Gaming Synthetic Data at Scale',
  challenge: {
    title: 'The Challenge',
    description:
      'Panenka, an AI-powered football manager game, needed to generate 10,000+ unique player profiles with:',
    items: [
      'Culturally diverse, realistic names from different countries',
      'Photorealistic player faces with distinct features',
      `Consistent aging progression over players' careers`,
      'No copyright violations or privacy concerns',
      'Cultural authenticity without stereotypes',
    ],
  },
  whyStandardToolsFailed: {
    title: 'Why Standard Tools Failed',
    items: [
      'Generic name generators: Repetitive, culturally inauthentic, famous name collisions',
      'Basic image generation: Inconsistent outputs, no aging capability',
      'Synthetic data platforms: Built for structured tabular data, not multi-modal gaming assets',
    ],
  },
  approach: (
    <>
      That’s when we’ve stepped in with Synthetic Data Generation! Our custom
      solution used GPT-4.0 with Chain of Thought prompting, combined with Self
      Consistency, to generate culturally relevant names based on nationality,
      considering each country's diversity and cultural influences while
      avoiding famous combinations.
      <br />
      <br />
      Our team developed a 'genetic' approach by creating lists describing
      facial elements like lips, noses, eyebrows, cheekbones, freckles, then
      used GPT-4.o to describe these features in sentences that Leonardo.ai
      could effectively process. We achieved dynamic player aging by storing the
      original prompt, seed, and other settings, ensuring consistency in
      appearance as players aged throughout their careers.
    </>
  ),
  result: (
    <>
      <b>Result:</b>Thousands of unique, culturally authentic player profiles
      with photorealistic, consistently aging visuals. With the use of synthetic
      data, we elevated the entire gaming experience!
    </>
  ),
};
